<template>
    <div>
        <home-common-search :from="'store'" :value="params.keywords"></home-common-search>
        <goodslist-body></goodslist-body>
        <common-store-footer :store_id="store_id"></common-store-footer>
    </div>
</template>

<script>
import CommonStoreFooter from '../common/CommonStoreFooter'
import HomeCommonSearch from '../common/HomeCommonSearch'
import { mapState, mapMutations } from 'vuex'
import GoodslistBody from './GoodslistBody'
export default {
  name: 'StoreGoodslist',
  components: {
      HomeCommonSearch,
    CommonStoreFooter,
    GoodslistBody
  },
  data () {
    return {
      store_id: this.$route.query.id ? this.$route.query.id : '',
      params: {
        keywords: this.$route.query.keywords ? this.$route.query.keywords : ''
      }

    }
  },
  created () {

  }
}
</script>

<style scoped lang="scss">
    .common-search{
        align-items: center;
        display: flex;
        padding:0.25rem $pageSpace;
        box-sizing: border-box;
        height: $headerHeight;
    }
    .common-search input {
        box-sizing: border-box;
        width: 100%;
        height: 1.6rem;
        border-radius:0.2rem;
        background: #EDEDED url(../../../assets/image/home/icon_search.png) no-repeat 0.6rem center;
        background-size:0.55rem;
        font-size:$fontSize;
        color: #999;
        padding-left:1.65rem;
        border: 0;
    }
</style>
